export const newsData = [
    {
        id: 95,
        title: "実績を新たに公開しました",
        title_en: "We have newly published our achievements.",
        description: "Japan Mobility Show2025のトヨタブース出展『Kids Mobi』のコンセプトムービーのリードリギング・モーション一部を担当しました。",
        description_en: "We were responsible for lead rigging and part of the motion work for the concept movie of “Kids Mobi,” showcased at the Toyota booth at Japan Mobility Show 2025.",
        category: "",
        category_en: "",
        link: "https://www.parnas.co.jp/work",
        link_en: "https://www.parnas.co.jp/work",
        image: "/images/022.jpg"
    },
    {
        id: 96,
        title: "26年3月卒新卒採用を開始しました。",
        title_en: "We have started recruiting new graduates for March 2026.",
        description: "2026年3月に卒業する専門学校生を募集します（リガー・TA職）。興味がある方は経歴書及びポートフォリオを添付の上、お問い合わせください。",
        description_en: "We are looking for vocational school students graduating in March 2026 for Rigger and Technical Artist positions. If you are interested, please send us your resume and portfolio as an attachment when inquiring.",
        category: "",
        category_en: "",
        link: "https://www.parnas.co.jp/recruitInfo",
        link_en: "https://www.parnas.co.jp/recruitInfo",
        image: "/images/VRchara_web_normal.png"
    }
];
